import { createContext } from 'react';
import getConfig from "next/config";
import qs from "qs";
import express from "express";

const RequestContext = createContext(null);
export default RequestContext;

export type RequestData = {
  hostname: string;
  query: any;
  contentServiceHost: string;
};

const {
  publicRuntimeConfig: {
    APP_ENV,
    CONTENT_SERVICE_HOST
  },
} = getConfig();

const getContentServiceHostFromCookies = (cookies: string): string => {
  let host = CONTENT_SERVICE_HOST;

  cookies.split(';').map(kv => kv.trim().split('=')).forEach(([k,v]) => {
    if(k==='content_branch') {
      host = `https://${v}-content.qa.education.com`;
    }
  });

  return host;
};

export function getRequestDataFromRequest(req?: express.Request): RequestData {
  const requestData = {
    hostname: 'www.fswadmin.com',
    query: {},
    contentServiceHost: CONTENT_SERVICE_HOST,
    referrer: '',
  };

  if(req) {
    requestData.hostname = req.hostname;
    requestData.query = req.query;

    // On QA, allow overriding content service host from a cookie
    if(APP_ENV==='qa') {
      requestData.contentServiceHost = getContentServiceHostFromCookies(req.headers.cookie || '');
    }

    requestData.referrer = req.headers.referer;
  }
  else if (typeof window !== 'undefined') {
    requestData.hostname = window.location.hostname;
    requestData.query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    // On QA, allow overriding content service host from a cookie
    if(APP_ENV==='qa') {
      requestData.contentServiceHost = getContentServiceHostFromCookies(document.cookie);
    }
  }

  return requestData;
}

